const PageHeading = ({ heading }: { heading: string }) => {
  return (
    <h2 className="cursor-default text-xl font-medium leading-7 tracking-wide text-gray-900">
      {heading}
    </h2>
  );
};

export { PageHeading };
